import { subHeadersStyles } from '@/consts/builder';
import beTwMerge from '@/utils/beTwMerge';
import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import { FAQItemType } from '@/types/builder';
import { useEffect, useState } from 'react';
import FAQ from './FAQ';

export default function FAQs({
  anchorLinkID,
  FAQList,
  mainTitle,
  mainTitleTag,
  margin,
}: {
  anchorLinkID: string;
  FAQList?: {
    header: string;
    headerTag: 'h1' | 'h2' | 'h3';
    items?: FAQItemType[];
  }[];
  mainTitle?: string;
  mainTitleTag: 'h1' | 'h2' | 'h3';
  margin: boolean;
}) {
  const MainTitleTag = mainTitleTag || 'h2';
  const [scriptLoaded, setScriptLoaded] = useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://script.brilliantearth.com/static/js/affirm/affirm_production.js';
    script.async = false;
    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  if (!scriptLoaded) {
    return null;
  }

  return (
    <div
      className={beTwMerge('tw-w-full tw-px-4 bs-tablet:tw-px-0', getComponentMargin(margin))}
      {...getAnchorId(anchorLinkID)}
    >
      {mainTitle && (
        <MainTitleTag
          className={beTwMerge(
            'tw-pt-4 tw-my-0 tw-pb-6 bs-tablet:tw-p-0 bs-tablet:tw-mb-[40px]',
            subHeadersStyles['h1']
          )}
        >
          {mainTitle}
        </MainTitleTag>
      )}
      <div className="tw-flex tw-flex-col tw-items-start tw-self-stretch tw-gap-6 bs-tablet:tw-gap-8">
        {FAQList?.map(faq => {
          const { header, headerTag, items } = faq;
          const HeaderTag = headerTag || 'h2';
          return (
            <div className="tw-w-full">
              {header && (
                <HeaderTag className={beTwMerge('tw-m-0 tw-mb-4 bs-tablet:tw-mb-6', subHeadersStyles[HeaderTag])}>
                  {header}
                </HeaderTag>
              )}
              <div className="tw-flex tw-flex-col tw-items-start tw-self-stretch tw-gap-4 bs-tablet:tw-gap-6">
                {items?.map((item, index) => <FAQ item={item} key={`FAQ_${index}`} />)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
